<template>

  <div>

    <div v-if="details.delete" class="hit-text-right hit-text-danger">
      <hit_icon :id="'bin'" /> {{ details.delete }}
    </div>

    <div v-if="!mail_send && !details.delete">

      <div class="hit-text-left hit-form-group">
        <a href="#" class="hit-btn hit-btn-default hit-btn-xs hit-btn-block" v-on:click.prevent="function(){open = !open; }">{{ $t("message.deletionRequest") }}</a>
      </div>

      <transition name="fade">
        <div class="hit-row" v-bind:key="open" v-if="open">
          <div class="hit-col-md-12">
            <div class="hit-panel hit-panel-default">
              <div class="hit-panel-heading" v-html="$t('message.reasonWhy')+': '+$t('message.deletionRequest')" />
            <div class="hit-form-group" spellcheck="false">
              <ckeditor id="privacy" :editor="editor" v-model="reasonWhy" :config="editorConfig"></ckeditor>
            </div>
          </div>
          </div>

          <div class="hit-col-md-12" v-show="reasonWhy">
            <div class="hit-panel hit-panel-default">
              <div class="hit-panel-heading" v-html="$t('message.preview')" />
                <div class="hit-form-group">
                  <div class="hit-list-group">
                  <div class="hit-list-group-item" v-html="get_text()"/>
                </div>
              </div>
            </div>

            <a href="#" class="hit-btn hit-btn-success hit-btn-block" v-on:click.prevent="send_mail()" v-text="$t('message.send')" v-if="reasonWhy" />
          </div>

        </div>
      </transition>
    </div>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'
import md5 from 'js-md5'

export default{

  props: {details: Object},

  data () {
    return {
      mail_send: false,
      open: false,
      reasonWhy: '',
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'bold', 'italic', 'link' ],
        language: 'de'
      }
    }
  },

  methods: {
    get_text () {
      return this.$nl2br(this.$t('email.conflictEmail.text', {link: this.get_link(), reasonWhy: '<span style="color: #55a79a">' + this.reasonWhy + '</span>', name: this.details.name, url: this.$get_url().www_url, user: this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name}))
    },

    get_link () {
      var url = this.$get_url().www_url + this.$router.resolve({ name: 'vote_conflict', params: {boardID: this.details.board, entryID: this.details.ID, userID: this.$store.getters.user.md5_id, lang: this.$store.getters.lang} }).href
      url = '<a href="' + url + '" target="_blank">' + url + '</a>'

      return url
    },

    send_mail () {
      this.$store.dispatch('set_conflict_mail', {board: this.details.board, ID: this.details.ID, user: this.$store.getters.user.md5_id, data: { email: { to: this.details.email, text: this.get_text(), title: this.$t('email.conflictEmail.title') } }})
      this.$store.dispatch('set_chat', { user: this.$store.getters.user.md5_id, data: { chat_nr: this.details.board + '-' + this.details.ID, msg: this.$t('email.conflictEmail.title') + ': ' + this.reasonWhy, user: 1, view: [1] }})
      this.$store.dispatch('set_chat', { user: this.$store.getters.user.md5_id, data: { chat_nr: this.details.board + '-' + this.details.ID, msg: this.$t('message.pleaseInsertReasonWhy', {name: this.details.name}), user: 2, view: [2] }})
      this.mail_send = true
    }
  }

}

</script>

<style scoped>
  .hit-list-group-item{
    overflow-wrap: break-word;
  }
</style>
